import { ref, onMounted } from 'vue'
import { once } from 'gleam-shared/helpers/nodash'
import { request } from 'gleam-shared/network/http'
import { createSharedComposable } from '@vueuse/core'
import { STAGING_ENV, DEVELOPMENT_ENV } from 'gleam-shared/helpers/env'

export default createSharedComposable(() => {
  const isLoggedIn = ref(null)
  const isLoggedInStatusReady = ref(false)
  const isTeamMember = ref(null)

  onMounted(once(() => {
    initLoggedIn()
    initTeamMember()
  }))

  return { isLoggedIn, isLoggedInStatusReady, isTeamMember }

  function initLoggedIn() {
    request('/signed-in').then((value) => {
      isLoggedIn.value = value
      isLoggedInStatusReady.value = true
    }, (err) => {
      console.warn('useHelpCenterVisitor: failed to check whether the user is logged in', err)
      isLoggedIn.value = false
    })
  }

  function initTeamMember() {
    if (STAGING_ENV || DEVELOPMENT_ENV) {
      isTeamMember.value = true
    } else {
      request('/gleam-team-member', { priority: 'low' }).then((value) => {
        isTeamMember.value = value
      }, (err) => {
        console.warn('useHelpCenterVisitor: failed to check whether the user is a team member', err)
        isTeamMember.value = false
      })
    }
  }
})
